import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

import AudioBody from './AudioBody';

const View = (props) => <AudioBody {...props} />;

export default withBlockExtensions(View);
